import React from 'react'
import { isMobile } from 'react-device-detect'
import {
  DcDropDown,
  DcInput,
  PixelButton,
  PixelFactoryContext,
  PixelHeaderPanel,
  PixelLeftPanel,
  PixelPageContainer,
  PixelRightPanel,
  Section,
  SectionContent,
  SectionForm,
  SectionTitle,
} from 'pixel-base'

import {
  getCourierSettings,
  updateShippingLabelRemarks,
} from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../decl'

const CourierSettings = () => {
  const { showLoader, hideLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const mainSectionRef = React.useRef(null)
  const [data, setData] = React.useState({
    shipping_label_remarks: '',
    shipping_label_product_print_option: '',
  })

  const [error, setError] = React.useState({ error: '', field: '' })
  React.useEffect(() => {
    fetchCompanyInfo()
  }, [])

  const fetchCompanyInfo = () => {
    showLoader(mainSectionRef)
    getCourierSettings().subscribe((res: any) => {
      setData({
        shipping_label_remarks: res.response.shipping_label_remarks,
        shipping_label_product_print_option:
          res.response.shipping_label_product_print_option,
      })
      hideLoader(mainSectionRef)
    })
  }
  const handleUpdateCompanyInfoRemarks = () => {
    showLoader(mainSectionRef)
    updateShippingLabelRemarks(data).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response) {
        setData({
          shipping_label_remarks: res.response.shipping_label_remarks,
          shipping_label_product_print_option:
            res.response.shipping_label_product_print_option,
        })
        showSuccess('Updated Successfully')
      } else {
        if (res.response && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response)
        }
      }
    })
  }

  const updateCourierSettings = (e) => {
    e.preventDefault()
    handleUpdateCompanyInfoRemarks()
  }
  return (
    <>
      <PixelPageContainer>
        <Section isMobile={isMobile}>
          <SectionTitle>Shipping Label Print Settings</SectionTitle>
          <SectionContent
            isMobile={isMobile}
            className="general-info-container"
            ref={mainSectionRef}
          >
            <SectionForm isMobile={isMobile} onSubmit={updateCourierSettings}>
              <PixelHeaderPanel>
                <PixelLeftPanel>
                  <Section>
                    <DcInput
                      error={
                        error.field === 'Shipping Label Remarks' &&
                        error.error !== ''
                          ? error.error
                          : null
                      }
                      required
                      type={'text'}
                      as={'textarea'}
                      name={'Shipping Label Remarks'}
                      placeholder={'Shipping Label Remarks'}
                      value={data.shipping_label_remarks || ''}
                      maxLength={255}
                      dimension="small"
                      onChange={(e) =>
                        setData({
                          ...data,
                          shipping_label_remarks: e.target.value,
                        })
                      }
                    />
                    &nbsp;
                    <DcDropDown
                      placeholder="Select Product Print Option"
                      style={{ backgroundColor: '#f6f6f6' }}
                      options={[
                        {
                          label: 'Print Product Name',
                          value: 'product_name',
                        },
                        {
                          label: 'Print SKU',
                          value: 'sku',
                        },
                        {
                          label: 'Print Both (Product & SKU)',
                          value: 'both',
                        },
                        {
                          label: 'Print None',
                          value: 'none',
                        },
                      ]}
                      value={data.shipping_label_product_print_option || ''}
                      onChange={(e) =>
                        setData({
                          ...data,
                          shipping_label_product_print_option: e.target.value,
                        })
                      }
                    />
                    <PixelButton
                      variant="primary"
                      padding="0.375rem 0.75rem"
                      margin="0.375rem 0"
                      type="submit"
                    >
                      Save
                    </PixelButton>
                  </Section>
                </PixelLeftPanel>
                <PixelRightPanel></PixelRightPanel>
              </PixelHeaderPanel>
            </SectionForm>
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default CourierSettings
